/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tokenaccessenabled2Inputs */

const de__field_tokenaccessenabled2 = /** @type {(inputs: _Field_Tokenaccessenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token-Anmeldung für Schüler:innen aktiviert`)
};

/**

* @param {_Field_Tokenaccessenabled2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_tokenaccessenabled2 = /** @type {((inputs?: _Field_Tokenaccessenabled2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tokenaccessenabled2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_tokenaccessenabled2(inputs)
});
export { _field_tokenaccessenabled2 as "_field_tokenAccessEnabled" }